import Media from "react-media";
import { useContext } from "react";
import styled from "styled-components";
import { UserContext } from "../../../../context";
import logo_sekolah from "../../../../assets/logo_sekolah.png";
import { Image, Header } from "semantic-ui-react";

const MoleculeSekolah = () => {
  const { state } = useContext(UserContext);
  return (
    <Media query={{ maxWidth: 768 }}>
      {(v) =>
        v ? null : (
          <Style nav={state.navigation.active ? true : state.navigation.hover}>
            <div className="logo-sekolah">
              <Image src={logo_sekolah} />
            </div>

            <Header
              className="nama-sekolah"
              style={{
                marginTop: 0,
                fontWeight: 600,
                fontSize: "1.4em",
                lineHeight: "1.2em",
              }}
              color="theme"
            >
              SMA IT Insan Mulia Surakarta
            </Header>
          </Style>
        )
      }
    </Media>
  );
};

const Style = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.nav ? "37px auto" : "1fr")};
  gap: 16px;
  padding: 16px;
  align-items: center;
  height: 54px;

  div > img {
    width: 2.8em;
  }

  .nama-sekolah {
    width: 8em;
    display: ${(props) => (props.nav ? "block" : "none")};
  }

  .logo-sekolah img {
    width: 8em;
    display: ${(props) => (props.nav ? "block" : "none")};
  }

  @media (max-width: 480px) {
    grid-template-columns: ${(props) =>
      props.nav ? "37px auto" : "37px auto"};
    gap: 10px;
    padding: 0;

    .dashboard-header {
      display: block;

      p {
        font-size: 12px;
        display: block;
      }
    }
  }
`;

export default MoleculeSekolah;
